<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-06 19:51:19
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-08 16:45:26
-->
<template>
	<div>
		<el-dialog title="提示" width="426px" show-close :visible.sync="visible" :close-on-click-modal="false">
			<div class="flex flex-align-center">
				<img src="@/assets/public/warning-org.png" class="warn-img" alt="" />
				<p class="fz-14 font-bold ml-6">账号是否授权成功？</p>
			</div>
			<div class="fz-14 mt-8 ml-22">
				若您授权失败，可
				<span class="yx-color-primary pointer" @click="confirm">重新授权</span>
				或
				<el-tooltip placement="top">
					<img slot="content" :src="baseInfo.partner_auth_code" alt="" width="160" height="160" />
					<a href="javascript:;" class="fz-14 mr-20 yx-color-primary">联系客服</a>
				</el-tooltip>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="ok">否</el-button>
				<el-button type="primary" @click="ok">是</el-button>
			</div>
		</el-dialog>
		<authStatusResult ref="authStatusResult"></authStatusResult>
	</div>
</template>
<script>
import authStatusResult from './authStatusResult.vue';
import { checkState } from '@/api/teamManage';
import mixin from '@/mixins';
import authMixin from './mixin';
export default {
	components: {
		authStatusResult,
	},
	mixins: [mixin, authMixin],
	data() {
		return {
			visible: false,
			link: '',
			content: '',
			platformId: '',
			call_id: 0,
		};
	},
	methods: {
		show(value, platformId, call_id) {
			this.platformId = platformId;
			this.call_id = call_id;
			this.link = value;
			this.visible = true;
		},
		confirm() {
			const { link, openBlankWindow } = this;
			openBlankWindow(link);
			this.visible = true;
		},
		async ok() {
			let params = {
				platformId: this.platformId,
				callId: this.call_id,
			};
			const { data } = await checkState(params);
			if (!data.auth_status) {
				this.$refs.authStatusResult.show(data.auth_status, this.platformId);
			}
			this.$emit('success');
			this.visible = false;
		},
	},
};
</script>
<style lang="less" scoped>
.warn-img {
	width: 16px;
	height: 16px;
}
</style>
